export default "__VITE_ASSET__CBYwisOu__"